if (!customElements.get("cart-upgrade-upsell")) {
  customElements.define(
    "cart-upgrade-upsell",
    class CartUpgradeUpsell extends HTMLElement {
      connectedCallback() {
        this.cta = this.querySelector(".wt-cart__upgrade-cta");
        this.dismissButton = this.querySelector(".wt-cart__upgrade-dismiss");
        this.errorElement = this.querySelector(".wt-cart__upgrade-error");
        this.spinner = this.querySelector(".loading-overlay__spinner");
        this.dismissButton.addEventListener("click", () => this.dismiss());
        this.cta.addEventListener("click", () => this.upgrade());
      }

      dismiss() {
        const wrapper = this.closest(".wt-cart__upgrade-item");
        (wrapper || this).remove();
      }

      currentQuantity() {
        const line = this.closest("li")?.previousElementSibling;
        const input = line?.querySelector(".js-counter-quantity");
        const value = Number(input?.value);
        return value > 0 ? value : Number(this.dataset.quantity);
      }

      setLoading(isLoading) {
        this.cta.disabled = isLoading;
        this.dismissButton.disabled = isLoading;
        this.cta.classList.toggle("loading", isLoading);
        this.spinner.classList.toggle("hidden", !isLoading);
      }

      defaultError() {
        return (
          (window.cartStrings && window.cartStrings.error) ||
          "Something went wrong. Please try again."
        );
      }

      showError(message) {
        this.errorElement.textContent = message || this.defaultError();
        this.errorElement.hidden = false;
      }

      async upgrade() {
        this.errorElement.hidden = true;
        this.setLoading(true);
        const cartDrawer = this.closest("cart-drawer");
        const item = {
          id: Number(this.dataset.upgradeVariantId),
          quantity: this.currentQuantity(),
        };
        if (this.dataset.packSize) {
          item.properties = { "Sqm per pack": this.dataset.packSize };
        }

        try {
          const addResponse = await fetch(`${routes.cart_add_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({ items: [item] }),
          });
          const addState = await addResponse.json();
          if (!addResponse.ok || addState.status) {
            this.showError(addState.description || addState.message);
            this.setLoading(false);
            return;
          }
        } catch (error) {
          this.showError();
          this.setLoading(false);
          return;
        }

        try {
          const body = JSON.stringify({
            id: this.dataset.lineKey,
            quantity: 0,
            sections: cartDrawer.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          });
          const changeResponse = await fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            body,
          });
          const state = await changeResponse.json();
          if (!changeResponse.ok || state.errors) {
            throw new Error(state.errors || state.message);
          }
          cartDrawer.renderContents(state, false);
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-upgrade-upsell" });
        } catch (error) {
          await this.recover(cartDrawer);
        }
      }

      async recover(cartDrawer) {
        try {
          const [cart, sections] = await Promise.all([
            fetch(`${routes.cart_url}.js`).then((response) => response.json()),
            fetch(
              `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`,
            ).then((response) => response.json()),
          ]);
          cart.sections = sections;
          cartDrawer.renderContents(cart, false);
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-upgrade-upsell" });
          const errors =
            document.getElementById("cart-errors") ||
            document.getElementById("CartDrawer-CartErrors");
          if (errors) {
            errors.textContent = this.defaultError();
          }
        } catch (error) {
          this.setLoading(false);
          this.showError();
        }
      }
    },
  );
}
